<div class="list-notificacoes" *ngIf="notificacoesAberta && habilitado">
    <div class="card col-12 d-flex" style="flex-direction: column;">
        <div class="card-header">Notificações</div>
        <div class="card-body" style="overflow: auto;">
            <div class="row">
                <div class="box">
                    <div *ngIf="listaNotificacoes.length > 0">
                        <div class="col-12 d-flex box-notificacao" *ngFor="let item of listaNotificacoes">
                            <div class="col-12 d-flex notificacao" (click)="redirecionamentoChamado(item.protocolo)">
                                {{item.conteudo}}<span class="hora">{{item.hora}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="notificacao" *ngIf="!(listaNotificacoes.length > 0)">
                    <span>Você não possui notificações</span>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="float" *ngIf="habilitado">
    <div class="back" (click)="click()" [class]="ativo?'click':''">
        <div class="float-text" *ngIf="ativo">
            <div class="not-text" [class]="ativo?'black':''">
                <span>{{msg}}{{protocolo}}</span>
            </div>
        </div>
        <div class="int" [class]="ativo?'black':''" (click)="abrirNotificacoesAntigas()">
            <div class="sing-pending" *ngIf="listaNotificacoes.length > 0 && temNotificacoesNaoVistas"></div>
            <i class="fa fa-bell" aria-hidden="true"></i>
        </div>
    </div>
</div>